import React from "react";
import { Step1PhoneRegisFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { Inputs, Buttons } from "components";

const Step1PhoneRegisForm = ({ onSubmit }) => {
  const { t } = useTranslation(["common"]);
  const schema = yup.object().shape({
    test: yup.string().required("New password is required"),
  });

  const {
    control,
    handleSubmit,
    // formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  return (
    <Step1PhoneRegisFormStyled>
      <div className="register_header">{t("Register with phone number", { ns: "common" })}</div>
      <div className="register_title">{t("Enter phone number", { ns: "common" })}</div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.TextField
              theme_standard2
              className="register_phone"
              label={t("Phone number", { ns: "common" })}
              placeholder="0812345678"
              {...field}
              // placeholder={t('test')}
              // errors={errors.phone?.message}
            />
          )}
          name="test"
          defaultValue=""
        />
      </form>
      <div className="register_button">
        <Buttons.BgStandard label={t("Register", { ns: "common" })} />
      </div>
      <div className="back">
        <div className="back_text">{t("Want to login another way!", { ns: "common" })}</div>
        <button className="back_button">{t("Go back", { ns: "common" })}</button>
      </div>
    </Step1PhoneRegisFormStyled>
  );
};

Step1PhoneRegisForm.propTypes = {};

export default Step1PhoneRegisForm;
